module.exports = __webpack_public_path__ + "img/p21.4b8ec21a.png";